import Query from "components/query/Query";

export default Query